import { FormField, SearchField } from '@/components/custom/erp';
import { QUERY_KEYS, vatTuSearchColumns } from '@/constants';
import { VatTu } from '@/types/schemas/vat-tu.type';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoProps {
  mode: FormMode;
  material: VatTu | null;
  setMaterial: (material: VatTu) => void;
}

function BasicInfo({ mode, material, setMaterial }: BasicInfoProps) {
  const isViewMode = mode === 'view';

  return (
    <div className='space-y-3 p-6'>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã vật tư</Label>
        <SearchField<VatTu>
          type='text'
          displayRelatedField={'ten_vt'}
          columnDisplay={'ma_vt'}
          searchEndpoint={`/${QUERY_KEYS.VAT_TU}`}
          searchColumns={vatTuSearchColumns}
          dialogTitle='Danh mục vật tư'
          value={material?.ma_vt || ''}
          relatedFieldValue={material?.ten_vt || ''}
          onRowSelection={setMaterial}
          disabled={isViewMode || mode === 'edit'}
          className='w-100'
        />
      </div>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Mã hàng hóa</Label>
        <FormField id='ma_khai_bao' type='text' name='ma_khai_bao' className='w-80' disabled={isViewMode} />
      </div>
      <div className='flex flex-col sm:flex-row sm:items-center'>
        <Label htmlFor='status' className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>
          Trạng thái
        </Label>
        <FormField
          id='status'
          type='select'
          name='status'
          className='w-60'
          options={[
            { label: '1. Còn sử dụng', value: '1' },
            { label: '0. Không sử dụng', value: '0' }
          ]}
          disabled={mode === 'view'}
        />
      </div>
    </div>
  );
}

export default BasicInfo;
